import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useSwipeable } from "react-swipeable";
import icons from "../../icons.config";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MdStar,
  MdStarHalf,
  MdStarOutline,
  MdArrowBackIos,
  MdArrowForwardIos,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { addLikedItem } from "../../store/likedItemsSlice";

import "./scroller.css";
import itemData from "../dressData";
import CustomSizeModal from "./modals/customSize";

import { selectClickedItem } from "../../store/itemsSlice"; // Import your selector
import { addToCart } from "../../Providers/cartProvider";
import SizeGuidePopup from "./modals/sizeGuidePopup";
import ImageModal from "./modals/imageModal";
import { setClickedItem } from "../../store/itemsSlice";
import { useParams } from "react-router-dom";
import { getProductById } from "../../Providers/shopProvider";
import { fetchFAQs } from "../../Providers/contactUsProvider";
import { FOUNDER_IMAGE_URL } from "../../api-urls";

const ViewDress = ({ item }) => {
  const { id } = useParams(); // Get product ID from URL
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null); // State for product data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bigImage, setBigImage] = useState("");
  const [smallImages, setSmallImages] = useState([]);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        const response = await getProductById(id); // Fetch product by ID
        console.log(
          "clicked item on view product page-----------------",
          response
        );
        setProduct(response);
        setBigImage(response.data?.selectedVariant.variant_images[0]); // Set main image
        setSmallImages(
          response.data?.selectedVariant.variant_thumbnail_images || []
        ); // Set small images
        dispatch(setClickedItem(response)); // Store in Redux
      } catch (error) {
        console.error("Error fetching product:", error);
        setError("Failed to fetch product details.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchProduct(); // Call API if ID is available
  }, [id, dispatch]);
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    const getFAQs = async () => {
      const faqData = await fetchFAQs();
      setFaqs(faqData.data);
    };
    getFAQs();
  }, []);

  const clickedItem = useSelector(selectClickedItem);
  const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);

  const handleCloseCustomModal = () => {
    setIsCustomModalOpen(false);
  };
  // const [quantity, setQuantity] = useState(1);
  // const [bigImage, setBigImage] = useState(clickedItem.thumbnail);
  // const [smallImages, setSmallImages] = useState([]);

  useEffect(() => {
    if (clickedItem && clickedItem.images) {
      setSmallImages(clickedItem.images);
    }
  }, [clickedItem]); // Re-run effect when clickedItem changes

  const [currentReviewIndex, setCurrentReviewIndex] = useState(0); // State to track the current review
  // const navigate = useNavigate(); // Initialize useNavigate

  const handleImageClick = (clickedImage, index, clickedItem) => {
    // Set the big image to the clicked small image
    // const updatedBigImage = clickedImage;

    // Update the small images array (not really needed here but added for clarity)
    const updatedSmallImages =
      clickedItem?.data?.selectedVariant?.variant_thumbnail_images?.map(
        (img) => img
      );

    const updatedBigImage =
      clickedItem?.data?.selectedVariant?.variant_images[index];

    // Update the state with the new big image and small images
    setBigImage(updatedBigImage);
    setSmallImages(updatedSmallImages);

    // Check if the clicked image is the last one in the current small images array
    if (
      index ===
      clickedItem.data?.selectedVariant?.variant_thumbnail_images.length - 1
    ) {
      setIsPopupOpen(true);
    }
  };

  // console.log(
  //   "Clicked item in View page:",
  //   JSON.stringify(clickedItem, null, 2)
  // );
  // Debugging line to verify the item

  useEffect(() => {
    // Set the initial quantity to 1 or whatever is relevant for the item
    // For example, it could be `clickedItem.initialQuantity` if it's available
    if (clickedItem) {
      setQuantity(1); // Set the initial value (if applicable)
    }
  }, [clickedItem]);

  const handleNextReview = () => {
    setCurrentReviewIndex((prevIndex) =>
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePreviousReview = () => {
    setCurrentReviewIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1
    );
  };

  const reviews = [
    {
      name: "ANGEL SINNGH",
      city: "New York",
      rating: 2.5,
      review:
        "Amazing dress! Fits perfectly and the fabric is high quality. Love it!",
    },
    {
      name: "DIPIKA",
      city: "Los Angeles",
      rating: 4,
      review:
        "Great dress, but the color was slightly different from the picture.",
    },
    {
      name: "ALIA BHATT",
      city: "Chicago",
      rating: 5,
      review: "Absolutely stunning! I get compliments every time I wear it.",
    },
  ];

  // const faqs = [
  //   {
  //     question: "What size does Dikost offer ?",
  //     answer:
  //       "We offer a wide range of sizes, including customizable sizes for dresses over XL, ensuring a perfect fit for every body type.",
  //   },
  //   {
  //     question: "What is your return policy ?",
  //     answer:
  //       "Our return policy allows for returns within 30 days of purchase with a valid receipt.",
  //   },
  //   {
  //     question: "How long does shipping take ?",
  //     answer:
  //       "Shipping typically takes between 3-5 business days for standard delivery.",
  //   },
  // ];
  const [activeIndex, setActiveIndex] = useState(null); // Track the active FAQ

  // Function to toggle visibility of answer
  const toggleFAQ = (index) => {
    // If the clicked index is already active, collapse it; otherwise, set it as active
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleItems, setVisibleItems] = useState(3); // Default for large screens
  const [autoPlay, setAutoPlay] = useState(true); // Auto-animate for smaller screens
  const [isFading, setIsFading] = useState(false); // Manage fading effect

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setVisibleItems(2); // Show 2 items on small and medium screens
        setAutoPlay(true); // Enable autoplay on smaller screens
      } else {
        setVisibleItems(4); // Show 3 items on large screens
        setAutoPlay(false); // Disable autoplay on larger screens
      }
    };

    handleResize(); // Set initial state based on window size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNext = () => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % itemData.length);
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
    console.log("next arrow clicked");
  };

  const handlePrev = () => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex - 1 + itemData.length) % itemData.length
      );
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
    console.log("previous arrow clicked");
  };

  const getVisibleDresses = () => {
    const endIndex = currentIndex + visibleItems;
    return itemData
      .slice(currentIndex, endIndex)
      .concat(
        itemData.slice(
          0,
          endIndex > itemData.length ? endIndex - itemData.length : 0
        )
      );
  };

  // Dots navigation logic
  const numberOfDots = Math.ceil(itemData.length / visibleItems);
  const handleDotClick = (index) => {
    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentIndex(index * visibleItems);
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
  };

  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });
  const handlers1 = useSwipeable({
    onSwipedLeft: handleNextReview,
    onSwipedRight: handlePreviousReview,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStars = rating % 1 !== 0 ? 1 : 0;
    const emptyStars = 5 - fullStars - halfStars;

    return (
      <div className="flex space-x-1">
        {Array(fullStars).fill(<MdStar className="text-review" />)}
        {halfStars === 1 && <MdStarHalf className="text-review" />}
        {Array(emptyStars).fill(<MdStarOutline className="text-review" />)}
      </div>
    );
  };

  const magnifierHeight = 650; // Height of the magnifier
  const magnifierWidth = 470; // Width of the magnifier
  const zoomLevel = 3; // Magnification level

  const [imgWidth, setImgWidth] = useState(0); // Image width
  const [imgHeight, setImgHeight] = useState(0); // Image height
  const [showMagnifier, setShowMagnifier] = useState(false); // Toggle magnifier
  const [[x, y], setXY] = useState([0, 0]); // Cursor position relative to image
  const handleDressClick = (item) => {
    console.log("Item received in handleDressClick:", item);

    if (!item) {
      console.error("Item is undefined or null");
      return;
    }

    // Remove non-serializable properties like 'window'
    const sanitizedItem = { ...item };

    // Remove non-serializable objects like Window, HTMLImageElement, etc.
    Object.keys(sanitizedItem).forEach((key) => {
      if (
        sanitizedItem[key] instanceof Window ||
        sanitizedItem[key] instanceof HTMLImageElement
      ) {
        delete sanitizedItem[key]; // Remove the property
      }
    });

    // Dispatch the sanitized item to Redux
    dispatch(setClickedItem(sanitizedItem));

    // Navigate to the product details page with the item's ID
    navigate(`/view/product/${item.id}`);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const imagesPerView = 3; // How many images to show at a time
  const [startIndex, setStartIndex] = useState(0);
  const [showFullCarousel, setShowFullCarousel] = useState(false); // Flag to toggle full carousel view

  const goToNextSlide = () => {
    if (startIndex + imagesPerView < smallImages.length) {
      setStartIndex((prev) => prev + 1);
    } else {
      // Loop back to start
    }
  };

  const goToPreviousSlide = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    } else {
      setShowFullCarousel(false); // Show +4 when going back to the beginning
    }
  };

  const handleOpenFullCarousel = () => {
    setShowFullCarousel(true); // Activate full carousel view
  };

  const [currentBigIndex, setCurrentBigIndex] = useState(0);

  const handleNextBig = () => {
    if (smallImages.length === 0) return; // Prevent errors if no images exist

    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentBigIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % smallImages.length;
        setBigImage(smallImages[newIndex]); // Update big image dynamically
        return newIndex;
      });
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
    console.log("Next arrow clicked");
  };

  const handlePrevBig = () => {
    if (smallImages.length === 0) return; // Prevent errors if no images exist

    setIsFading(true); // Start fading effect
    setTimeout(() => {
      setCurrentBigIndex((prevIndex) => {
        const newIndex =
          (prevIndex - 1 + smallImages.length) % smallImages.length;
        setBigImage(smallImages[newIndex]); // Update big image dynamically
        return newIndex;
      });
      setIsFading(false); // End fading after image swap
    }, 500); // Match fade duration
    console.log("Previous arrow clicked");
  };

  // const dispatch = useDispatch();

  const handleHeartClick = (dress) => {
    dispatch(addLikedItem(dress)); // Add the item to the global state
    console.log(`Liked: ${dress.title}`);
  };

  const [isChartPopUpOpen, setIsChartPopUpOpen] = useState(false);

  const toggleChartPopUp = () => {
    setIsChartPopUpOpen((prev) => {
      if (!prev) {
        // If the popup is opening, disable background scroll
        document.body.classList.add("no-scroll");
      } else {
        // If the popup is closing, enable background scroll
        document.body.classList.remove("no-scroll");
      }
      return !prev;
    });
  };
  // const handleAddToCart = () => {
  //   dispatch(addToCart(clickedItem));  // Dispatch the addToCart action to add the item
  // };

  const [selectedSize, setSelectedSize] = useState("");

  const handleSizeSelection = (size) => {
    setSelectedSize(size);
  };
  const [buttonText, setButtonText] = useState("ADD TO CART"); // Initial button text
  // const handleAddToCart = () => {
  //   // console.log("Add to cart---", clickedItem,);
  //   if (clickedItem
  //     // && clickedItem.price
  //     // && selectedSize
  //   ) {
  //     // Pass the selected size along with other item data
  //     /// TODO: Selected Size for the cart
  //     let selectedSize = "M"
  //     dispatch(addToCart({ ...clickedItem, quantity,selectedSize }));

  //     // dispatch(addToCart({ ...clickedItem, quantity, selectedSize }));
  //   } else {
  //     console.error("Item is missing price, size or is undefined!");
  //   }
  //   setButtonText("ADDED TO CART!");

  //   // Reset text after 3 seconds
  //   setTimeout(() => setButtonText("ADD TO CART"), 3000);
  // };
  const handleAddToCart = () => {
    console.log("clickedItem:", clickedItem);

    if (!clickedItem?.data?.selectedVariant?.id) {
      console.error("❌ Item is missing selectedVariant ID!");
      return;
    }

    // const selectedSize = clickedItem?.size || "M"; // Default size if not provided
    const quantityToAdd = quantity || 1;

    const cartItem = {
      clickedItem, // Send the full clickedItem object
      selectedSize,
      quantity: quantityToAdd,
    };

    console.log("📩 Dispatching addToCart with:", cartItem);

    dispatch(addToCart(cartItem))
      .then((res) => {
        console.log("✅ Add to cart success:", res);
      })
      .catch((err) => {
        console.error("❌ Add to cart failed:", err);
      });

    setButtonText("ADDED TO CART!");
    setTimeout(() => setButtonText("ADD TO CART"), 3000);
  };

  // Inside your component
  const [selectedColor, setSelectedColor] = useState(null);

  // const handleColorSelection = (color) => {
  //   setSelectedColor(color); // Set the selected color
  // };
  const handleColorSelection = (color) => {
    setSelectedColor(color);
    navigate(`/${color.slug}`); // Redirect to the new product page
  };
  const location = useLocation();
  const handleBuyNow = () => {
    const gst = clickedItem.discountedPrice * 0.18; // GST on discounted price
    const totalPrice = clickedItem.discountedPrice + gst;

    navigate("/checkout", {
      state: {
        item: clickedItem,
        gst,
        totalPrice,
        selectedSize,
        selectedColor,
        quantity: quantity,
        fromProduct: location.pathname,
      },
    });
  };

  const likedItems = useSelector((state) => state.likedItems); // Get the list of liked items from the store

  return (
    <>
      <div className="bg-tertiary w-full z-10 px-7 lg:px-0 " {...handlers1}>
        <div className="hidden lg:flex absolute right-0">
          <img
            src={icons.viewPageCircles}
            alt="circles icon"
            className="w-48 h-48 lg:h-64 lg:w-64"
          />
        </div>
        {isCustomModalOpen && (
          <div className="fixed inset-0  z-50  flex items-center justify-center   backdrop-blur-sm">
            <CustomSizeModal onClose={handleCloseCustomModal} />
          </div>
        )}
        <div className="max-w-full lg:max-w-[82%] xl:max-w-[83%] 2xl:max-w-[84%] mx-auto px-1 pt-28 md:pt-32 pb-10 grid grid-cols-1 lg:grid-cols-2 gap-6 ">
          {/* Left Section */}
          <div className="flex flex-col ">
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-9 px-2 lg:px-0 relative left-1 lg:left-0">
              <div className="lg:hidden  w-full relative ">
                {/* Heart Icon */}
                <div className="absolute top-6 right-6 text-primary1 font-light z-20">
                  <img
                    src={icons.heart}
                    alt="Heart Icon"
                    className="w-7 h-7 md:w-8 md:h-8"
                  />
                </div>

                {/* Image */}
                <img
                  src={FOUNDER_IMAGE_URL + bigImage}
                  alt="Big Dress"
                  className="w-full h-full object-cover "
                />
              </div>

              <div className="lg:hidden w-full ">
                {showFullCarousel ? (
                  <div className="relative">
                    <div className="flex flex-row gap-4 md:gap-9">
                      {smallImages
                        .slice(startIndex, startIndex + imagesPerView + 1)
                        .map((image, index) => (
                          <img
                            key={index}
                            src={FOUNDER_IMAGE_URL + image}
                            alt={`Image ${startIndex + index + 1}`}
                            className="w-[21%] h-auto cursor-pointer border border-primary1"
                            onClick={() =>
                              handleImageClick(image, index, clickedItem)
                            }
                          />
                        ))}
                    </div>

                    {/* Arrows for full carousel navigation */}

                    <img
                      src={icons.arrowLeft}
                      alt="left arrow"
                      className="absolute top-[50%] -left-2 md:-left-3 transform -translate-y-1/2 text-primary1 text-lg font-semibold w-5 h-5 md:w-7 md:h-7 rounded-[50%] z-20 bg-secondary cursor-pointer"
                      onClick={goToPreviousSlide}
                    />

                    <img
                      src={icons.arrowRight}
                      alt="right arrow"
                      className="absolute top-[50%] -right-2 md:-right-3 transform -translate-y-1/2   text-primary1 rounded-[50%] bg-secondary w-5 h-5 md:w-7 md:h-7 z-10 cursor-pointer"
                      onClick={goToNextSlide}
                    />
                  </div>
                ) : (
                  <div className="relative flex flex-row w-[20%] gap-5">
                    {/* Show the first set of small images */}
                    {smallImages.slice(0, imagesPerView).map((image, index) => (
                      <img
                        key={index}
                        src={FOUNDER_IMAGE_URL + image}
                        alt={`Image ${index + 1}`}
                        className="w-full cursor-pointer border border-primary1"
                        onClick={() => handleImageClick(image)}
                      />
                    ))}

                    {/* Show the +4 counter on the last image */}
                    <div className="relative ">
                      <img
                        src={FOUNDER_IMAGE_URL + smallImages[imagesPerView - 1]} // Display the last small image
                        alt="Last Image"
                        className="cursor-pointer w-full h-full border border-primary1"
                        onClick={handleOpenFullCarousel}
                      />
                      <div className="relative -top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 text-hcolor text-xl font-semibold">
                        +{smallImages.length - imagesPerView}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Grid Layout for Larger Screens */}
              <div className="hidden lg:flex flex-col gap-6  w-1/6 relative lg:top-12 px-2 cursor-pointer">
                {smallImages.slice(0, 3).map((image, index) => (
                  <img
                    key={index}
                    src={FOUNDER_IMAGE_URL + image}
                    alt={`Image ${index + 1}`}
                    className="w-full h-[19%] cursor-pointer"
                    onClick={() => handleImageClick(image, index, clickedItem)}
                  />
                ))}

                {/* Last Image with Counter */}
                <div className="relative w-full h-auto">
                  <img
                    src={
                      FOUNDER_IMAGE_URL + smallImages[smallImages.length - 4]
                    }
                    alt="Last Image"
                    className="w-auto h-[115%] 2xl:h-[110%] cursor-pointer border border-primary1"
                    onClick={handleOpenModal}
                  />
                  <div
                    className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 text-hcolor text-xl font-semibold"
                    onClick={handleOpenModal}
                  >
                    +{smallImages.length - 4}
                  </div>
                </div>
              </div>

              <div className="hidden lg:flex w-3/4 lg:h-[110%] xl:h-screen py-12 relative">
                {/* Heart Icon */}
                <div className="absolute top-16 right-3 text-primary1 font-light z-20">
                  <img
                    src={icons.heart}
                    alt="Heart Icon"
                    className="w-5 h-5 md:w-7 md:h-7"
                  />
                </div>

                {/* Image */}
                <img
                  src={FOUNDER_IMAGE_URL + bigImage}
                  alt="Big Dress"
                  className="w-full h-[90%] 2xl:h-full object-cover cursor-grab "
                  onMouseEnter={(e) => {
                    const elem = e.currentTarget;
                    const { width, height } = elem.getBoundingClientRect();
                    setImgWidth(width);
                    setImgHeight(height);
                    setShowMagnifier(true);
                  }}
                  onMouseMove={(e) => {
                    const elem = e.currentTarget;
                    const { top, left } = elem.getBoundingClientRect();
                    const x = e.pageX - left - window.pageXOffset;
                    const y = e.pageY - top - window.pageYOffset;
                    setXY([x, y]);
                  }}
                  onMouseLeave={() => {
                    setShowMagnifier(false);
                  }}
                />
                {showMagnifier && (
                  <div
                    className="absolute top-10 left-0 h-full border border-gray-200 bg-white pointer-events-none"
                    style={{
                      width: `${magnifierWidth}px`,
                      height: `${magnifierHeight}px`,

                      backgroundImage: `url('${bigImage}')`,
                      backgroundSize: `${imgWidth * zoomLevel}px ${
                        imgHeight * zoomLevel
                      }px`,
                      backgroundPositionX: `${
                        -x * zoomLevel + magnifierWidth / 2
                      }px`,
                      backgroundPositionY: `${
                        -y * zoomLevel + magnifierHeight / 2
                      }px`,
                      zIndex: 10,
                    }}
                  />
                )}
              </div>
            </div>

            {isModalOpen && (
              <ImageModal
                isOpen={isModalOpen}
                handleClose={handleCloseModal}
                bigImage={FOUNDER_IMAGE_URL + bigImage}
                smallImages={FOUNDER_IMAGE_URL + smallImages}
                clickedItem={clickedItem}
                handleImageClick={handleImageClick}
                handleNextBig={handleNextBig}
                handlePrevBig={handlePrevBig}
                icons={icons}
              />
            )}

            {/* Reviews Carousel */}
            <div className="hidden lg:block relative w-full max-w-3xl  py-6 ">
              <h1 className="text-primary1 flex justify-center text-xl font-outfit font-light">
                REVIEWS
              </h1>
              {/* Previous Arrow */}
              <img
                src={icons.arrowLeft} // Replace with the path to your left arrow icon
                alt="Previous Review"
                className="absolute left-0 top-[50%] transform -translate-y-1/2 w-8 h-8 lg:w-8 lg:h-8 rounded-full bg-secondary z-20 hidden lg:block cursor-pointer"
                onClick={handlePreviousReview}
              />

              {/* Reviews Content */}
              <div className="bg-gray-100 p-3 rounded-lg text-center ">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={currentReviewIndex}
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -50 }}
                    transition={{ duration: 0.5 }}
                  >
                    {/* Star Rating */}
                    <div className="flex justify-center mb-2 ">
                      {renderStars(reviews[currentReviewIndex].rating)}
                    </div>

                    {/* Reviewer Details */}
                    <div className="text-center mb-2">
                      <p className="font-outfit font-normal text-2xl text-primary1">
                        {reviews[currentReviewIndex].name}
                      </p>
                      <p className="text-sm font-outfit text-hcolor font-light">
                        {reviews[currentReviewIndex].city}
                      </p>
                    </div>

                    {/* Review Text */}
                    <p className="text-sm text-hcolor text-center font-outfit font-light">
                      "{reviews[currentReviewIndex].review}"
                    </p>
                  </motion.div>
                </AnimatePresence>
              </div>

              {/* Next Arrow */}
              <img
                src={icons.arrowRight} // Replace with the path to your right arrow icon
                alt="Next Review"
                className="absolute right-0 top-[50%] transform -translate-y-1/2 w-8 h-8 lg:w-8 lg:h-8 rounded-full bg-secondary z-20 hidden lg:block cursor-pointer"
                onClick={handleNextReview}
              />
            </div>
          </div>
          {/* Right Section */}
          <div className=" relative top-10 lg:left-6 px-2 lg:px-9">
            {/* Heading */}
            <h1 className="text-2xl lg:text-3xl xl:text-4xl font-outfit font-light">
              {product?.data?.product_name}
            </h1>

            {/* Material */}
            <p className="text-hcolor font-outfit my-1">
              Material: 100% {clickedItem.material}
            </p>
            <div className="lg:space-y-2 xl:space-y-11 2xl:space-y-7">
              <h2 className="text-xl font-semibold flex justify-start items-center my-7">
                <span className="lg:text-lg xl:text-xl text-primary1 line-through mr-6">
                  Rs. {product?.data?.selectedVariant.price}
                </span>
                <span className="lg:text-lg xl:text-xl text-hcolor">
                  Rs. {product?.data?.selectedVariant.discount_price}{" "}
                </span>
              </h2>
              <div className="border border-primary2 my-8"></div>
              {/* Size Chart */}
              <div>
                <div className="flex justify-between">
                  <h3 className="text-sm font-normal font-outfit mb-4 text-primary1">
                    SIZE
                  </h3>
                  {/*Size Chart PopUp */}
                  <SizeGuidePopup />
                </div>

                {/* <div> */}
                <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 gap-x-6 lg:pr-3 lg:pt-3 2xl:pt-0">
                  {product?.data?.selectedVariant.sizes.map((size, index) => (
                    <button
                      key={index}
                      className={`py-1 px-0 text-hcolor hover:bg-hcolor hover:text-tertiary border border-hcolor ${
                        selectedSize === size.size_name
                          ? "bg-hcolor text-tertiary border border-secondary"
                          : "" // Highlight selected size
                      }`}
                      onClick={() => handleSizeSelection(size.size_name)} // Set selected size
                    >
                      {size.size_name}
                    </button>
                  ))}
                </div>

                {/* Message for size selection */}
                {/* {!selectedSize && (
                    <p className="text-hcolor text-md mt-2">
                      * Please choose your size.
                    </p>
                  )}
                </div> */}

                <button
                  className="mb-4 mt-5 lg:mt-6 2xl:mt-4 px-6 md:px-16 lg:px-6 py-2 border border-hcolor bg-hcolor text-tertiary hover:bg-secondary hover:text-hcolor"
                  onClick={() => setIsCustomModalOpen(true)}
                >
                  CUSTOM SIZE
                </button>
              </div>

              {/* Quantity and Color */}
              <div className="flex flex-col lg:flex-row gap-5 lg:gap-20 lg:my-2 2xl:my-3">
                <div>
                  <h3 className="text-lg font-normal font-outfit mb-2">
                    Quantity
                  </h3>
                  <div className="flex items-center space-x-4 mt-2">
                    {/* Decrease Quantity */}
                    <button
                      onClick={() =>
                        setQuantity((prev) => Math.max(prev - 1, 1))
                      }
                      className="px-4 py-5 bg-tertiary text-hcolor font-bold hover:bg-primary2 focus:outline-none border border-secondary"
                      aria-label="Decrease Quantity"
                    >
                      <img src={icons.decreaseQ} alt="decrease quantity" />
                    </button>

                    {/* Quantity Input */}

                    <span className="text-2xl font-light font-outfit text-hcolor">
                      {quantity}
                    </span>

                    {/* Increase Quantity */}
                    <button
                      onClick={() => setQuantity((prev) => prev + 1)}
                      className="px-4 py-4 bg-tertiary text-hcolor font-bold  hover:bg-primary2 focus:outline-none border border-secondary "
                      aria-label="Increase Quantity"
                    >
                      <img src={icons.increaseQ} alt="increase quantity" />
                    </button>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-normal font-outfit mb-2">
                    Color
                  </h3>
                  <div className="flex gap-3">
                    {product?.data?.colors?.map(
                      (color, index) => (
                        console.log(color),
                        (
                          <div
                            key={index}
                            onClick={() => handleColorSelection(color)}
                            className={`w-10 h-10 rounded-full border-4 cursor-pointer ${
                              selectedColor === color.color_code
                                ? "border-primary"
                                : "border-secondary"
                            }`}
                            style={{ backgroundColor: color.color_code }}
                          ></div>
                        )
                      )
                    )}
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-col lg:flex-row gap-4 my-11">
                <button
                  className="flex-1 px-5 py-2 bg-tertiary text-hcolor hover:bg-hcolor hover:text-tertiary border-2 border-hcolor"
                  onClick={handleAddToCart}
                >
                  {buttonText}
                </button>
                <button
                  className="flex-1 px-5 py-2 border-2 border-hcolor bg-hcolor text-tertiary hover:bg-tertiary hover:text-hcolor"
                  onClick={handleBuyNow}
                >
                  BUY
                </button>
              </div>

              {/* Description */}
              <div>
                <h3 className="text-lg text-primary1 mb-2 font-normal font-poppins my-4">
                  About this dress
                </h3>
                {/* <p className="text-hcolor font-poppins text-sm font-extralight">
                  Bodycon maxi dress with scoop neck in the front and a deep
                  round neck in the back 
                  <br />- No pads 
                  <br />- No lining 
                  <br />- No closure
                  <br />
                  Model Fit - Yashvika with chest 33", waist 24" and hip 37" is
                  wearing size S/8.
                  <br />
                  Composition- Polyester stretch lycra
                  <br />
                  Care- handwash, flat iron, wash with alike colours
                  <br />
                  Fit recommendation- The fabric has ample stretch and we
                  recommend choosing the size closest to your body measurements
                  for a snatched look. For a relaxed fit, choose one size up
                  from your body measurements.
                </p> */}
                <p className="text-hcolor font-poppins text-sm font-extralight">
                  {product?.data?.info
                    ? product.data.info
                        .split(/\r?\n/)
                        .map((line, index) => <div key={index}>{line}</div>)
                    : "No information available"}
                </p>
              </div>

              {/* FAQs */}

              <div className="relative overflow-hidden mt-16">
                <div className="max-w-full mx-auto">
                  {/* FAQs Heading */}

                  <div className="space-y-5">
                    {faqs.map((faq, index) => (
                      <div
                        key={index}
                        className="border-b border-primary2 pb-2"
                      >
                        {/* Question Section */}
                        <div
                          className="flex justify-between items-center cursor-pointer"
                          onClick={() => toggleFAQ(index)} // Handle toggling FAQ
                        >
                          <h3 className="text-md font-normal text-primary1">
                            {faq.question}
                          </h3>
                          {/* Plus/Minus Icon Toggle */}
                          {activeIndex === index ? (
                            <img
                              src={icons.minus}
                              alt="Collapse"
                              className="w-4 h-4"
                            />
                          ) : (
                            <img
                              src={icons.plus}
                              alt="Expand"
                              className="w-5 h-5"
                            />
                          )}
                        </div>

                        {/* Answer Section */}
                        <div
                          className={`overflow-hidden transition-all duration-500 ease-in-out ${
                            activeIndex === index
                              ? "max-h-[300px] opacity-100"
                              : "max-h-0 opacity-0"
                          }`}
                        >
                          <p className="mt-3 text-hcolor max-w-[90%]">
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Reviews Carousel */}
        <div className="lg:hidden relative w-full max-w-3xl mx-auto pt-14">
          <h1 className="text-primary1 flex justify-center text-2xl font-outfit font-light">
            REVIEWS
          </h1>

          {/* Reviews Content */}
          <div className="bg-gray-100 p-3 rounded-lg text-center">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentReviewIndex}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                {/* Star Rating */}
                <div className="flex justify-center mb-2">
                  {renderStars(reviews[currentReviewIndex].rating)}
                </div>

                {/* Reviewer Details */}
                <div className="text-center mb-2">
                  <p className="font-outfit font-normal text-2xl text-primary1">
                    {reviews[currentReviewIndex].name}
                  </p>
                  <p className="text-sm font-outfit text-hcolor font-light">
                    {reviews[currentReviewIndex].city}
                  </p>
                </div>

                {/* Review Text */}
                <p className="text-sm text-hcolor text-center font-outfit font-light">
                  "{reviews[currentReviewIndex].review}"
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Dots for Navigation */}
          <div className="flex justify-center  z-10 relative top-5">
            {Array.from({ length: reviews.length }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentReviewIndex(index)}
                className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full 
          ${
            index === currentReviewIndex
              ? "bg-hcolor"
              : "bg-white border border-hcolor"
          } 
          shadow-lg`}
              />
            ))}
          </div>
        </div>

        <div className="hidden lg:inline absolute lg:left-[4%] lg:bottom-[-47%] xl:bottom-[-60%] 2xl:bottom-[-73%] z-20">
          <img
            src={icons.collectionFlower}
            alt="Doodle Left"
            className="lg:w-24"
          />
        </div>
      </div>

      <div>
        <div className="flex flex-col justify-center items-center w-full h-full bg-tertiary pt-16 lg:pt-24 pb-24 xl:pb-0 relative  space-y-5 -mb-14 ">
          <div className="lg:hidden  relative top-[88%] md:top-[85%] right-[35%] ">
            <img
              src={icons.viewDressFlower1M}
              alt="circles icon"
              className="w-16 h-16 md:w-32 md:h-32 "
            />
          </div>

          {/* <div className="lg:hidden relative left-[5%] md:bottom-52 bottom-24 z-10">
        <img src={icons.collectionFlower} alt="Doodle Left" className="w-16 md:w-20" />
      </div> */}
          <h1 className="text-primary1 font-poppins text-3xl lg:py-16  mt-4 font-extralight mb-10">
            YOU MAY ALSO LIKE
          </h1>
          <div className="lg:hidden absolute right-0 top-[25%] ">
            <img
              src={icons.viewDressCirclesM}
              alt="Doodle Left"
              className="w-32 md:w-48"
            />
          </div>
          <div className="hidden lg:flex absolute right-0 top-[28%] ">
            <img
              src={icons.viewDressCircles2}
              alt="Doodle Left"
              className="w-48 xl:w-52"
            />
          </div>

          <div
            className="relative w-full  lg:max-w-[82%] xl:max-w-[83%] 2xl:max-w-[84%] h-full "
            {...handlers}
          >
            {/* Hide buttons on smaller screens */}
            <img
              src={icons.arrowLeft}
              alt="left arrow"
              className="absolute lg:left-7 xl:-left-1 top-[45%] transform -translate-y-1/2 text-primary1 text-lg font-semibold w-8 h-8 rounded-[50%] z-20 bg-secondary hidden lg:block cursor-pointer"
              onClick={handlePrev}
            />

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10 lg:gap-6 px-11 md:px-11  xl:px-2  ">
              {getVisibleDresses().map((item) => (
                <div
                  key={item.id}
                  className="text-left flex justify-center relative z-10"
                >
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={item.id}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      transition={{ duration: 0.5 }}
                      className={`transition-opacity duration-500 ${
                        isFading ? "opacity-0" : "opacity-100"
                      }`}
                    >
                      {/* Dress Image */}
                      <motion.img
                        src={item.images[0]}
                        alt={item.title}
                        className="w-full h-[85%] md:h-[90%] md:w-[100%] object-cover mb-4 "
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 2.5 }}
                        onClick={() => handleDressClick(item)}
                      />

                      {/* Heart Icon (positioned in the top-right corner of the image) */}
                      <div
                        onClick={() => handleHeartClick(item)}
                        className="absolute top-4 right-4 text-primary1 font-light "
                      >
                        {/* <img
                          src={
                            likedItems.some(
                              (likedItem) => likedItem.id === item.id
                            )
                              ? icons.filledHeart
                              : icons.heart
                          }
                          alt="Heart Icon"
                          className="w-5 h-5 md:w-7 md:h-7"
                        /> */}
                      </div>

                      <motion.h2
                        className="font-light mt-2 font-outfit text-xl text-primary1"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1.5 }}
                      >
                        {item.title}
                      </motion.h2>

                      {/* Description */}
                      <motion.p
                        className="text-sm mt-1 text-hcolor font-poppins font-light"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1.5 }}
                      >
                        {item.price}
                      </motion.p>
                    </motion.div>
                  </AnimatePresence>
                </div>
              ))}
            </div>

            <img
              src={icons.arrowRight}
              alt="right arrow"
              className="absolute top-[45%] lg:right-7 xl:-right-2 transform -translate-y-1/2  hidden text-primary1 rounded-[50%] bg-secondary  lg:block w-8 h-8 z-10 cursor-pointer"
              onClick={handleNext}
            />
          </div>
          <div className="flex justify-center pt-8  lg:hidden relative top-7">
            {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
              <button
                key={dotIndex}
                onClick={() => handleDotClick(dotIndex)}
                className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full 
        ${
          dotIndex === Math.floor(currentIndex / visibleItems)
            ? "bg-hcolor"
            : "bg-white border border-hcolor"
        } 
        shadow-lg`}
              />
            ))}
          </div>

          {/* <div className='lg:hidden'>
        <div className="absolute left-0 top-20 z-0">
          <img src={icons.collectionMCircle} alt="Doodle Left" className="w-full " />
        </div>
        <div className='absolute right-6 bottom-16 '>
          <img src={icons.collectionMFlower} alt="Doodle Right" className="w-full " />
        </div>
      </div>

      <div className='flex justify-center mt-16 pt-10 pb-1'>
        <button className='border-2 py-2 px-4 flex text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 transition-all duration-500 ease-in-out'>
          VIEW ALL
        </button>
      </div> */}

          <div className="lg:hidden  absolute top-[88%] md:top-[85%] right-6 ">
            <img
              src={icons.viewDressFlower2M}
              alt="circles icon"
              className="w-16 h-16 md:w-32 md:h-32 "
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDress;
